import { Component, Inject, PLATFORM_ID } from '@angular/core';
import { NavigationEnd, Router, Event as RouterEvent } from '@angular/router';
import { ApiService } from '../../helpers/api.service';
import { isPlatformBrowser } from '@angular/common';


@Component({
  selector: 'app-app-layout',
  templateUrl: './app-layout.component.html',
  styleUrl: './app-layout.component.css'
})
export class AppLayoutComponent {
  store: any;
  showTopButton = false;
  constructor(
    private service: ApiService, 
    private router: Router,
    @Inject(PLATFORM_ID) private platformId: Object,
  ) {
    //this.initStore();
  }

  headerClass = '';
  ngOnInit() {
    // this.initAnimation();
    // this.toggleLoader();
    if (isPlatformBrowser(this.platformId)) {
      window.addEventListener('scroll', () => {
        if (document.body.scrollTop > 50 || document.documentElement.scrollTop > 50) {
          this.showTopButton = true;
        } else {
          this.showTopButton = false;
        }
      });
    }
  }

  ngOnDestroy() {
    if (isPlatformBrowser(this.platformId)){
      window.removeEventListener('scroll', () => { });
    }
  }

  // initAnimation() {
  //   //this.service.changeAnimation();
  //   this.router.events.subscribe((event) => {
  //     if (event instanceof NavigationEnd) {
  //       //this.service.changeAnimation();
  //     }
  //   });

  //   const ele: any = document.querySelector('.animation');
  //   ele.addEventListener('animationend', () => {
  //     this.service.changeAnimation('remove');
  //   });
  // }

  // toggleLoader() {
  //   this.storeData.dispatch({ type: 'toggleMainLoader', payload: true });
  //   setTimeout(() => {
  //     this.storeData.dispatch({ type: 'toggleMainLoader', payload: false });
  //   }, 500);
  // }

  // async initStore() {
  //   this.storeData
  //     .select((d) => d.index)
  //     .subscribe((d) => {
  //       this.store = d;
  //     });
  // }

  goToTop() {
    document.body.scrollTop = 0;
    document.documentElement.scrollTop = 0;
  }
}
